import { render, staticRenderFns } from "./TucowsPromosExpired.vue?vue&type=template&id=a5372a8c"
import script from "./TucowsPromosExpired.vue?vue&type=script&lang=js"
export * from "./TucowsPromosExpired.vue?vue&type=script&lang=js"
import style0 from "./TucowsPromosExpired.vue?vue&type=style&index=0&id=a5372a8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports